import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { BkgLogo } from "@/components/store/Logo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    const result = await login(form.email, form.password);
    if (!result.ok) setError(result.error);
    setLoading(false);
  };

  return (
    <main className="relative grid min-h-screen place-items-center overflow-hidden bg-void px-5" data-testid="admin-login-page">
      <div className="absolute -right-20 top-10 font-heading text-[24vw] font-black italic text-outline opacity-20">BKG</div>
      <motion.form initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} onSubmit={submit} className="glass-panel relative z-10 w-full max-w-md p-8" data-testid="admin-login-form">
        <BkgLogo testId="login-brand-link" />
        <h1 className="mt-10 font-heading text-5xl font-black italic tracking-tighter">Admin studio</h1>
        <p className="mt-3 text-sm text-zinc-500">Enter the control room for products and orders.</p>
        <div className="mt-8 space-y-5">
          <Input data-testid="admin-email-input" type="email" required placeholder="Admin email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="h-12 rounded-none border-x-0 border-t-0 bg-transparent" />
          <Input data-testid="admin-password-input" type="password" required placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="h-12 rounded-none border-x-0 border-t-0 bg-transparent" />
        </div>
        {error && <p data-testid="admin-login-error" className="mt-4 text-sm text-neon">{error}</p>}
        <Button data-testid="admin-login-submit-button" disabled={loading} className="kinetic-button mt-8 h-12 w-full rounded-none bg-volt font-bold uppercase tracking-[0.2em] text-black hover:bg-transparent hover:text-volt">
          {loading ? "Opening studio..." : "Enter studio"}
        </Button>
      </motion.form>
    </main>
  );
}
